export class SearchParameter {
  public currentSearchText: string;
  public activeRegularExpressionButtonList: string[];
  public initializSearch?: boolean;
  public isAllMatchActive?: boolean;
  constructor() {}
}
export class ButtonSettings {
  public icon?: string;
  public caption?: string;
  public Tooltip?: string;
  public activeStatus?: boolean;

  constructor() {}
}

export enum REGEX_FLAG {
  GENERAL = 'gi',
  MATCHCASE = 'g',
  WOHLEWORD = 'gi',
  MATCHCASE_WOHLEWORD = 'g',
}

export enum MatchMode {
  search_all = 'search_all',
  search_down = 'search_down',
  search_up = 'search_up',
}

export enum ReplaceMode {
  replace_one = 'replace_one',
  replace_all = 'replace_all',
}

export enum RegExpMode {
  match_case = 'search_case',
  whole_word = 'whole_word',
}
